import { MessageStatsView } from '@zola/svc-marketplace-ts-types';

import { createAction } from '@reduxjs/toolkit';

export const RECEIVED_MESSAGE_STATS = 'zola/couple/RECEIVED_MESSAGE_STATS';

export const receivedMessageStats = createAction<MessageStatsView>(RECEIVED_MESSAGE_STATS);
